// removed by extract-text-webpack-plugin
module.exports = {"gallery":"src-components-Gallery----styles-module---gallery---2GR95","thumbnails":"src-components-Gallery----styles-module---thumbnails---2FhD2","thumbnail":"src-components-Gallery----styles-module---thumbnail---3RUyQ","thumbnailImg":"src-components-Gallery----styles-module---thumbnailImg---2-S-Q","arrowButton":"src-components-Gallery----styles-module---arrowButton---w5tbT","arrow":"src-components-Gallery----styles-module---arrow---26bY9","left":"src-components-Gallery----styles-module---left---3mO9E","right":"src-components-Gallery----styles-module---right---1BDWS"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Gallery/styles.module.css
// module id = 501
// module chunks = 168707334958949